import { Injectable } from '@angular/core'
import { MatDialogConfig } from '@angular/material/dialog'
import { BdcClosePropertyDialogComponent } from './bdc-close-property-dialog.component'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { filter } from 'rxjs/operators'

@Injectable()
export class BdcClosePropertyDialogService {
  constructor(private dialog: DialogService) {}

  open(propertyId: number) {
    const defaultConfig: MatDialogConfig = {
      width: '500px',
      height: 'auto',
      data: { propertyId },
    }

    return this.dialog
      .openFixedDialog(BdcClosePropertyDialogComponent, defaultConfig)
      .afterClosed()
      .pipe(filter((s) => s === 'success'))
  }
}
